export default __webpack_public_path__ + "static/media/ushop.a27554e2.png";